
















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import ApplicationModeService from '@/utils/application-mode-service';
import { SmartQuery } from 'vue-apollo-decorator';
import { UNIT_INVOICE_SETTINGS } from '@/queries/CompanySetting';
import { GQL_unitInvoiceSetting, GQL_unitInvoiceSetting_currentUnit_unitSetting_unitInvoiceSetting } from '@/queries/__generated__/unitInvoiceSetting';
import PermissionService from '@/utils/permission-service';

@Component
export default class InvoicingMode extends Vue {
  private handleOpen = ApplicationModeService.sidebarExpanded;
  private PermissionService = PermissionService;
  private isDebugMode: boolean = process.env.VUE_APP_DEBUG_PAGES === 'true';

  @SmartQuery<InvoicingMode, GQL_unitInvoiceSetting>({
    query: () => UNIT_INVOICE_SETTINGS,
    update: (data) => data.currentUnit.unitSetting.unitInvoiceSetting,
  }) public unitInvoiceSetting!: GQL_unitInvoiceSetting_currentUnit_unitSetting_unitInvoiceSetting;

  @Watch('handleOpen')
  private onExpandChange(value: boolean): void {
    ApplicationModeService.toggleSidebarExpanded(value);
  }
}
